module.exports = __webpack_public_path__ + "static/media/sortingdown-gray.c56328d5.svg";